<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}">课程介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">麦语言介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">订课须知</li>
            <!-- <li @click="num = 3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p class="intent">
                本课程针对初级量化交易自学者编制，以视频为主配有PPT知识点学习指导，每个章节按了解概念->讲述方法->指导编写->分析案例的过程分步展开。
            </p>
            <br>
            <p>
                *本课程基于<common-data name="appShortName_11"/>软件的量化交易编程语言-麦语言编制。
            </p>
            <p>
                *授课形式为线上视频。
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        
        
        <div class="details_gn" v-show="num == 1">
            <p class="intent">麦语言倡导的是积木式的编程理念，把复杂算法封装到一个个的函数里，采用"小语法，大函数"的构建模式，大幅提高编写效率，其他语言100多句的模型，用麦语言一般10几句就可以编出来。配合专门的量化交易数据结构，配合丰富的金融统计函数库，同样可以支持逻辑复杂的金融应用。
            </p>
            <p class="intent">
                麦语言经过二十年的发展，吸收数十万用户的意见反馈，一点一点完善起来的，成长为一套成熟稳定、使用人数最多的模型开发编程语言之一。
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">· 线上课程视频入口：<a href="https://wt8.wenhua.com.cn/" target="_blank"><common-data name="appShortName_11"/>官网</a>->购买->模型编写视频教程。
            </p>
            <p class="tent">· 订课后，一年内可无限次听课。
            </p>
            
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn{
    min-height: 255px;
}
.details_gn p.tent {
    
}
</style>